// extracted by mini-css-extract-plugin
export var discard = "_37-3";
export var muiTooltipTooltip = "_37-5";
export var notificationBar = "_37-2";
export var saveButtonHoverSlotWrapper = "_37-4";
export var show = "_37-1";
export var spacer = "_37-0";